import type { FaireProductEntity } from "../../entity_types/product";

export const p_hdfm7k8nxv: FaireProductEntity = {
  token: "p_hdfm7k8nxv",
  type: "product",
  name: "Batter Up Baseball Sweatshirt",
  brandToken: "b_b6dwdx0bqo",
  brandName: "Shop Southern Belle",
  imageUrl:
    "https://cdn.faire.com/fastly/aeb71ef584e528f5a1cfc935b362fc18ff4709473a79c7b0dd26ddd8dcbf6623.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/202b8c5dc9356d9dee7da9b566c0ea25c82a6b63674c541a63ea3c5ceabae901.jpeg",
    "https://cdn.faire.com/fastly/2f24ec3d12416dee2d7388905127d30c67be0f52d24211a2425df1f56a867131.jpeg",
    "https://cdn.faire.com/fastly/95f7a55a0082bdb91d8f5d205fa5be992cfbb0157428e0bce1173371b5f0d58e.png",
    "https://cdn.faire.com/fastly/787f567eb37cd4c6e2dc4e2e38ddaac792b264a3b72819d47daa58c1aa0b7767.png",
  ],
  priceDollars: 22,
  description:
    "MSRP: $48\n\nClassic comfort meets color with these unisex crewneck sweatshirts! Compliments any wardrobe, these shirts provide the perfect fit and the soft feel essential for everyday wear.\n\nFit: Adult Unisex - True to Size\n\nCare: HANDWASH ONLY",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:55.787Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
